import React, { useState } from "react";
import "../assets/css/responsive.css";
import "../assets/css/style.css";
import "../assets/css/hamburger.css";

import Hero from "../components/main/hero";
import About from "../components/main/about";
import Services from "../components/main/services";
import Team from "../components/main/team";
import Presence from "../components/main/presence";
import Contact from "../components/main/contact";
import Footer from "../components/main/footer";

const Main = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main">
      <Hero />
      <About />
      <Services />
      <Team />
      <Presence />
      <Contact />
      <Footer />
    </div>
  );
};

export default Main;
